export var BOARD_TRANSLATIONS = {
    board: {
        header: {
            title: {
                default: 'Haga las configuraciones abajo para activar su tienda',
                completed: 'Todo listo, aguarda la aprobación',
                approve: 'Listo, ¡bienvenido a Rappi!',
                error: 'Corrige el error para que continuamos con el proceso',
                medium: '¡Falta poco para activar tu tienda y vender en Rappi!',
                defaultMobile: 'Configura para activar su tienda',
                completedMobile: 'Todo listo, aguarda la aprobación',
                approveMobile: '¡Aprobado! Haz tu primera venta',
                errormobile: 'Corrige el error para que continuamos con el proceso',
                mediumMobile: '¡Falta poco para activar tu tienda y vender en Rappi!',
            },
            subtitle: {
                default: 'Agrega la información abajo para terminar el proceso de aprobación de tu restaurante',
                completed: 'Completa todos los pasos a continuación y seguir al proceso de aprobación.',
                approve: 'Accede a Portal Partners y Aliados para recibir tu primera orden',
                medium: 'Termina de agregar la información para continuar con el proceso de aprobación',
                defaultMobile: 'Complete los pasos y espere el proceso de aprobación',
                completedMobile: 'Complete los pasos y espere el proceso de aprobación',
                approveMobile: 'Listo! Bienvenido a Rappi!',
                mediumMobile: 'Termina de agregar la información',
            },
        },
        board: {
            title: {
                open: 'Esperando llenado',
                processing: 'En revisión',
                error: 'Rechazado',
                valid: 'Aprobado',
                completed: 'Completado',
                locked: 'Esperando llenado',
                validAndLocked: 'Aprobado',
                processingAndLocked: 'En revisión',
                processingWithIA: 'En curso',
                processingWithIAAndLocked: 'En curso',
                generatedWithIA: 'Generado',
            },
            buttons: {
                open: 'Llenar',
                processing: 'Revisar',
                valid: 'Revisar',
                completed: 'Revisar',
                error: 'Ver motivo',
                locked: 'Revisar',
                validAndLocked: 'Revisar',
                processingAndLocked: 'Revisar',
                processingWithIA: 'Revisar',
                processingWithIAAndLocked: 'Revisar',
                generatedWithIA: 'Configurar',
            },
        },
        modal: {
            subtitle: 'Motivo de rechazo',
            body: {
                nextStep: 'Próximos pasos',
                description: 'Sigue los pasos anteriores para los datos que fallaron. Haz clic en “Revisar ahora“ para volver y cambiar datos o documentos.',
            },
            buttons: {
                now: 'Revisar ahora',
                after: 'Ver después',
            },
        },
    },
};
